import React, { useState,useEffect } from 'react'
import Navbar from '../navbar/navbar'
import { NumericFormat } from 'react-number-format'
import './compra.css';
import BuscaVazaia from '../components/buscavazia/buscaVazia';
import api from '../../services/api';
import { vhostV1, vhostV2 } from '../funcoes';
import ModalItens from './modalItens';
import ModalAssociacao from './modalAssociacao';
import ModalProduto from '../components/modalProduto/ModalProduto';
import { Link, Navigate, useNavigate, useParams} from 'react-router-dom'
import FooterBar from '../footer/footerBar';
import './compra.css'
import ModalEdicaoProduto from './modalEdicaoProduto';
import SRI_pagination from '../components/pagination/pagination';
import ModalCheckAssociar from './modalcheckAssociar';
import { Button } from 'react-bootstrap';
import { Toolbar } from '@mui/material';
import SweetAlert from 'react-bootstrap-sweetalert';


function NovaCompra(){

  const {id} = useParams();
  const {tag} = useParams();

  
  

  var data = new Date();
  var dia = String(data.getDate()).padStart(2, '0');
  var mes = String(data.getMonth() + 1).padStart(2, '0');
  var ano = data.getFullYear();
  const dataAtual = dia + '/' + mes + '/' + ano;

    let config = {
        headers: {
          'Authorization': localStorage.getItem("token")
        }
      }

   

    const [isModalItensOpen,setIsModalItensOpen] = useState(false);
    const [totalPedido,setTotalPedido] = useState(0);
    const [file, setFile] = useState(null);
    const [gridProduto,setGridProduto] = useState(false);
    const [sResult,setSresult] = useState(0);
    const [produtosBusca,setProdutosBusca] = useState([])
    const [produtos,setProdutos] = useState([])
    const [pesquisaProduto,setPesquisaProduto] = useState('');
    const [cnpjEmitente,setCnpjEmitente] = useState('');
    const [razaoEmitente,setRazaoEmitente] = useState('');
    const [isNovoClienteOpen, setIsNovoClienteOpen] = useState(false);
    const [resultPessoa,setResultPessoa] = useState();
    const [buscaPessoa,setBuscaPessoa] = useState("");
    const [clienteId, setClienteId] = useState(0);
    const [pessoas,setPessoas] = useState();
    const [prodAssociar,setProdAssociar] = useState('');
    const [isProdutoOpen,setIsProdutoOpen] = useState(false);
    const [diferenteZero,setDiferenteZero] = useState(false);
    const [estoqueNegativo,setEstoqueNegativo] = useState(false);
    const [vendaZerada,setVendaZerada] = useState(false);
    const [prodInativo,setProdInativo] = useState(false);
    const [codProduto,setcodProduto] = useState('');
    const [descProduto,setDescProduto] = useState('');
    const [codCompra,setCodCompra] = useState('');
    const [chave,setChave] = useState('');
    const [itens, setItens] = useState([]);
    const [qtd, setQtd] = useState(0); 
    const [descricao, setDescricao] = useState('');
    const [vendaDefault, setVendaDefault]= useState(0);
    const [produtosFiltro, setProdutosFiltro] = useState([]);
    const [cidade, setCidade] = useState('');
    const [uf, setUf] = useState('');
    const [cep, setCep] = useState('');
    const [bairro, setBairro] = useState('');
    const [numero, setNumero] = useState('');
    const [codMunicipal, setCodMunicipal] = useState('');
    const [estoque, setEstoque] = useState(0);
    const [ncm, setNcm] = useState('');

    const [cGrupo,setCgrupo] = useState(0);
     const [cSubGrupo,setCsubGrupo] = useState(0);
     const [cLinha,setClinha] = useState(0);

     const [usaDcadastro,setUsaDcadastro] = useState(false);
     const [usaDAlteracao,setusaDalteracao] = useState(false);
     const [usaDultCompra,setusaDultcompra] = useState(false);
     const [usaDultVenda,setusaDultvenda] = useState(false);

     const [dCadastro,setDcadastro] = useState(new Date);
     const [dAlteracao,setDalteracao] = useState(new Date);
     const [dultCompra,setDultcompra] = useState(new Date);
     const [dultVenda,setDultvenda] = useState(new Date);
     const [compra, setCompra] = useState(0);
     const [duplicata, setDuplicata] = useState([]);
     const [dataEmissao, setDataEmissao] = useState('');
     const [nProtocolo, setNProtocolo] = useState('');

     const [codFornecedor, setCodFornecedor] = useState(0);

     const [valorIcms, setValorIcms] = useState(0);
     const [valorBc, setValorBc] = useState(0);
     const [valorIcmsDeson, setValorIcmsDeson] = useState(0);
     const [valorFcp, setValorFcp] = useState(0);
     const [valorBcSt, setValorBcSt] = useState(0);
     const [valorSt, setValorSt] = useState(0);
     const [valorFcpSt, setValorFcpSt] = useState(0);
     const [valorFcpStRet, setValorFcpStRet] = useState(0);
     const [valorProd, setValorProd] = useState(0);
     const [valorFrete, setValorFrete] = useState(0);
     const [valorSeg, setValorSeg] = useState(0);
     const [valorDesc, setValorDesc] = useState(0);
     const [valorII, setValorII] = useState(0);
     const [valorIpi, setValorIpi] = useState(0);
     const [valorIpiDevol, setValorIpiDevol] = useState(0);
     const [valorPis, setValorPis] = useState(0);
     const [valorCofins, setValorCofins] = useState(0);
     const [valorOutros, setValorOutros] = useState(0);
     const [valorNotaFiscal, setValorNotaFiscal] = useState(0);
     const [valorTotalTrib, setValorTotalTrib] = useState(0);
     const [produtosState, setProdutosState] = useState(produtos);
     const [sucesso, setSucesso] = useState("N");
     const [isEditandoOpen, setIsEditandoOpen] = useState(false);
     const [numeroNF, setNumeroNF] = useState(0);
     const [totalPaginas, setTotalPaginas] = useState(1);
     const [nPag, setnPag] = useState(1);
     const [att, setAtt] = useState(false);
     const [checkIsOpen, setCheckIsOpen] = useState(false);

     const [produtoEditando, setProdutoEditando] = useState(null);
     const [resetar, setResetar] = useState("N");
     const [edicaoOn, setEdicaoOn] = useState(false);
     const [addProduto, setAddProduto] = useState(false);

     const [msgErro, setmsgErro] = useState("");
     const [erroValidacao, setErroValidacao] = useState(false);

     const abreModalEdicao = (produto) => {
      setProdutoEditando(produto);
      setIsEditandoOpen(true);
    };
  
    const fecharModal = () => {
      setProdutoEditando(null);
      setIsEditandoOpen(false);
    }
    
    const handleAtt = () => {
    setAtt(!att);
  }

  useEffect(function(){
    setCodCompra(id)
  },[id]);
  
  
  function abreModalProduto(e){
      e.preventDefault();
      setAddProduto(true);
    }

  const salvarEdicao = (produtoAtualizado) => {
    const sJson ={
      codCompra: codCompra,
      item: produtoAtualizado
    }

 
   

    api.post(vhostV1('webcash/compras/nota/item'),sJson,config)
            .then(function (response) {
                    
              console.log(response);
              setIsEditandoOpen(false);
              handleAtt();
              
                                          
                       
            })
            .catch(function (error) {
             
              console.log(error);
    
                      
            });
    
  };


 
     

  function handlePageChange(value){
    if(value === "&laquo;" || value === '... '){
      setnPag(1);
    }else if (value === "&lsaquo;" ){
      if (nPag !== 1){
        setnPag(-1);
      }
    }else if(value === "&rsaquo;"){
      setnPag(+1);        
    }else if(value === "&raquo;" || value === ' ...' ){
      setnPag(totalPaginas);        
    }else{
      setnPag(value);
    }    
   
   }
    
    
    
    

       function openModalProduto(e){
        e.preventDefault();
         if(clienteId === 0){
          setmsgErro("Selecione um fornecedor para adicionar produtos")
          setErroValidacao(true);
          setIsProdutoOpen(false);
         }else{
          setIsProdutoOpen(true)
         }
          
       }

       function closeModalProduto(codigoProdutoSelecionado){
  setIsProdutoOpen(false)

  api.post(
    vhostV1('webcash/compras/inserir/produtoManual'),
    {
      codigoProduto: codigoProdutoSelecionado,
      codigoCompra: codCompra
    },
    config
  )
  .then(function(response){
    console.log(response);

    setResetar("S");
    setAtt(prev => !prev);
  })
  .catch(function(error){
    console.error(error);
  })
}
    
       
 


 let qtdArray = produtos?.map((p) => {
  return p.QTD
 })




 function openModalCheck(){
  setCheckIsOpen(true)
 }

 function closeModalCheck(){
  setCheckIsOpen(false)
  setResetar("S");
  setAtt(!att)
 };
 
 


    function openModalItens(){
      setIsModalItensOpen(true)
   }

   function closeModalItens(){
      setIsModalItensOpen(false)
   }


    // const handleFileChange = (event) => {
    //     const selectedFile = event.target.files[0];
    //     setChave(selectedFile.name)
    //     setFile(selectedFile);
        
    // };

    const handleUpload = () => {
        if (file) {
        const reader = new FileReader();
        reader.onload = () => {
            const base64Data = reader.result.split(',')[1]; 
            // Envie o base64Data aqui
            enviaXml(base64Data);
           
            
                    
        };
        reader.readAsDataURL(file);
        }
    };


    async function enviaXml(sXml){
       
       
        
        let response = {};
        try {
          response = await api.post(vhostV1('webcash/compras/xml'),{
            xmlBase64:sXml,
            COD_COMPRA: String(codCompra)
          }, config)

          console.log(response);

          
          
          
          if(response.data.dados.fornecedor !== null){
            setCnpjEmitente(response.data.dados.fornecedor.cnpj);          
            setRazaoEmitente(response.data.dados.fornecedor.nome); 
            setCodFornecedor(response.data.dados.fornecedor.codigoFornecedor);          
            }

           
          if(response.data.dados.endereco !== null){
              setCidade(response.data.dados.endereco.nomeMunicipio);
              setUf(response.data.dados.endereco.uf);
              setCep(response.data.dados.endereco.cep);
              setBairro(response.data.dados.endereco.bairro);
              setNumero(response.data.dados.endereco.numero);
              setCodMunicipal(response.data.dados.endereco.codigoMunicipal);
                }  

          if(response.data.dados.itens !== null){
           setItens(response.data.dados.itens);  
           setProdutos(response.data.dados.itens);
               }  
               
          if(response.data.dados.cobr !== null){
               setDuplicata(response.data.dados.cobr.dup);
              }
                    
                    
          if(response.data.dados.nfe !== null){         
           setNumeroNF(response.data.dados.nfe.nNF);
           setDataEmissao(response.data.dados.nfe.dataEmissao);          
           setChave(response.data.dados.nfe.chaveNFe);
           setNProtocolo(response.data.dados.nfe.numeroDeProtocolo);           
                  }

           if(response.data.dados.cabecalho !== null){
            setValorBc(response.data.dados.cabecalho.ICMSTot.vBC);
            setValorIcms(response.data.dados.cabecalho.ICMSTot.vICMS);        
               setValorBcSt(response.data.dados.cabecalho.ICMSTot.vBCST);
               setValorSt(response.data.dados.cabecalho.ICMSTot.vST);        
               setValorProd(response.data.dados.cabecalho.ICMSTot.vProd);
               setValorFrete(response.data.dados.cabecalho.ICMSTot.vFrete);
               setValorSeg(response.data.dados.cabecalho.ICMSTot.vSeg);
               setValorDesc(response.data.dados.cabecalho.ICMSTot.vDesc);       
               setValorIpi(response.data.dados.cabecalho.ICMSTot.vIPI);
               setValorOutros(response.data.dados.cabecalho.ICMSTot.vOutro);
               setValorNotaFiscal(response.data.dados.cabecalho.ICMSTot.vNF);
                 }
                      

          setSresult(1);
          openModalCheck();
          // retornaCompra(codCompra)
          
        
          
         // setIsModalItensOpen(true)

        } catch (error) {
          console.log(error);          
        }
         
            
        //setItens(response.data.dados); 
        //setResultItens(response.data.result)     
      
      }



      // function abreAssociacao(cod){
      //   setProdAssociar(cod);

      //   setIsModalAssociacaoOpen(true);
      // }

      function abreLancaItem(cod){
        setcodProduto(cod);
        //setProdAssociar(cod) 
        setIsProdutoOpen(false)
       
      }  

      useEffect(function(){
     
        //console.log('numero de Paniga '+nPag);
        const sJson = {}
        sJson.loja=localStorage.getItem('loja'); 
        sJson.empresa=0;
        sJson.grupo=cGrupo;
        sJson.subgrupo=cSubGrupo;
        sJson.linha=cLinha;
        if(usaDcadastro === true)
        { sJson.data_cadastro=dCadastro}
        if(usaDAlteracao === true)
        { sJson.data_alteracao=dAlteracao}
        if(usaDultCompra === true)
        { sJson.data_compra=dultCompra}
        if(usaDultVenda === true)
        { sJson.data_venda=dultVenda}
        sJson.estoque_diferente=diferenteZero
        sJson.estoque_negativo=estoqueNegativo;
        sJson.preco_zerado=vendaZerada;
        sJson.inativo=false;
        sJson.pagina= 1;
        sJson.regPag=100000;
        sJson.busca= pesquisaProduto; 
        sJson.tipoBusca=0; 
        sJson.tipo_prod='';                  
        
          api.post(vhostV1('webcash/produto/listar'),sJson,config)
            .then(function (response) {
                    
              setProdutosFiltro(response.data.dados); 
              setSresult(response.data.result)
             
              
                                          
                       
            })
            .catch(function (error) {
             
              console.log(error);
    
                      
            });
      
            
          },[])

      function filtraProdutos(e){
        console.log(pesquisaProduto)
        e.preventDefault();
        const sJson = {}
        sJson.loja=localStorage.getItem('loja'); 
        sJson.empresa=0;
        sJson.grupo=0;
        sJson.subgrupo=0;
        sJson.linha=0;
        sJson.estoque_diferente=diferenteZero
        sJson.estoque_negativo=estoqueNegativo;
        sJson.preco_zerado=vendaZerada;
        sJson.inativo=prodInativo;
        sJson.pagina= 1;
        sJson.regPag=10000;
        sJson.busca= pesquisaProduto;   
        sJson.tipoBusca=0; 
        sJson.tipo_prod='';    
        
          api.post(vhostV1('webcash/produto/listar'),sJson,config)
            .then(function (response) {
                if(response && response.data && response.data.dados ){
                           
                    setProdutosBusca(response.data.dados);  
                }else{ 
                    setProdutosBusca([]);  
            }
                                         
            })
            .catch(function (error) {
              console.log(error);                  
            });
             
      }

      function salvaConta(e){
        e.preventDefault();
        const sJson = {
          COD_COMPRA: codCompra,
          total: totalPedido,
          cnpj: cnpjEmitente,                 
          itens: produtos,
          nNF: numeroNF,
          cabecalho: {
            vBC: Number(valorBc),
            vICMS: Number(valorIcms),
            vICMSDeson: Number(valorIcmsDeson),
            vFCP: Number(valorFcp),
            vBCST: Number(valorBcSt),
            vST: Number(valorSt),
            vFCPST: Number(valorFcpSt),
            vFCPSTRet: Number(valorFcpStRet),
            vProd: Number(valorProd),
            vFrete: Number(valorFrete),
            vSeg: Number(valorSeg),
            vDesc: Number(valorDesc),
            vII: Number(valorII),
            vIPI: Number(valorIpi),
            vIPIDevol: Number(valorIpiDevol),
            vPIS: Number(valorPis),
            vCOFINS: Number(valorCofins),
            vOutro: Number(valorOutros),
            vNF: Number(valorNotaFiscal),
            vTotTrib: Number(valorTotalTrib)
          }
        }
        console.log(sJson);
        api.post(vhostV1('webcash/compras/concluir'), sJson, config)
        .then(function(response) {
          console.log("salvei");
          
         
            console.log(response);
           setSucesso("S");

          
        }).catch(function (error){
          console.log("erro ao salvar");
          
          console.log(error);
        })
      }


     

       
        
    

       // criando um pedido
        useEffect(function(){
            
          if(Number(tag) !== -1 ){
            return
          }else{
          let response;       
       
          (async () => {
            try{
              response = await api.post(vhostV1('webcash/compras/inserir'), {
                empresa:0,
                loja:0,
                codColaborador: localStorage.getItem("colaborador"),
                cod_compra:codCompra,
                },config);
             
                console.log(response);
                
                if(response && response.data && response.data.dados ){
                  
                  handleRetorno(response.data.dados);
                }

              }catch(err){
               
                console.log(err.mensagem);
            }
          })()
        }
          
      },[])

     
      function handleClosePage(){
        if(produtos.length === 0){
          api.delete(vhostV1('webcash/compras/deletar/nota/'+codCompra),config)
          .then(function(response){
            console.log(response);
            setSucesso("S");
            
          }).catch(function (error){
            console.log(error);
            
          })
        }else{
          setSucesso("S")
        }
      };

       function handleRetorno(id){
          setCodCompra(id)
          retornaCompra(id)
        }  


        function converterData(data) {
         
          const [ano, mes, dia] = data.split('-');
          
          
          return `${dia}/${mes}/${ano}`;
        }
        
        function formatDate(dateString) {
          const date = new Date(dateString);
          const day = String(date.getDate()).padStart(2, '0');
          const month = String(date.getMonth() + 1).padStart(2, '0'); 
          const year = date.getFullYear();
        
          return `${day}/${month}/${year}`;
        }

        function validarData(dataString) {
          var data;
      
          // Verifica se a data está no formato "dd/mm/yyyy"
          if (/^\d{2}\/\d{2}\/\d{4}$/.test(dataString)) {
              var partes = dataString.split('/');
              var dia = parseInt(partes[0]);
              var mes = parseInt(partes[1]) - 1; // Mês começa do zero (janeiro é 0)
              var ano = parseInt(partes[2]);
              data = new Date(ano, mes, dia);
      
              // Verifica se a data é válida
              if (data.getDate() !== dia || data.getMonth() !== mes || data.getFullYear() !== ano) {
                  return null;
              }
          } else {
              // Tenta criar data a partir do formato ISO (ex: "2022-12-30T03:00:00.000Z")
              data = new Date(dataString);
              if (isNaN(data.getTime())) {
                  return null; // Data inválida
              }
          }
      
          // Formata a data no formato "yyyy-mm-dd"
            var dataFormatada = ('0' + data.getDate()).slice(-2) + '/' +
              ('0' + (data.getMonth() + 1)).slice(-2) + '/' +
              data.getFullYear();
          return dataFormatada;
      }
     

      function retornaCompra(id){
         
        api.post(vhostV1('webcash/compras/id'),{
          pagina: nPag,
          regPag: 10,
          id: id
        },config)
         .then(function (response) {
          console.log(response);
          
           if(response && response.data && response.data.dados){

            if(response.data.dados.quantidadeDePaginasTotal !== null){
              setTotalPaginas(response.data.dados.quantidadeDePaginasTotal); 
             }

             if(response.data.dados.dup !== null){
              setDuplicata(response.data.dados.dup);
             }

            if(response.data.dados.fornecedor !== null){
              setCnpjEmitente(response.data.dados.fornecedor.cnpj);          
              setRazaoEmitente(response.data.dados.fornecedor.nome);
              setClienteId(response.data.dados.fornecedor.codCadastro); 
              setCodFornecedor(response.data.dados.fornecedor.codigoFornecedor);          
             }
  
             
            if(response.data.dados.endereco !== null){
                setCidade(response.data.dados.endereco.nomeMunicipio);
                setUf(response.data.dados.endereco.uf);
                setCep(response.data.dados.endereco.cep);
                setBairro(response.data.dados.endereco.bairro);
                setNumero(response.data.dados.endereco.numero);
                setCodMunicipal(response.data.dados.endereco.codigoMunicipal);
            }  
  
            if(response.data.dados.itens !== null){
             setItens(response.data.dados.itens);  
             setProdutos(response.data.dados.itens);
            } 

            if(response.data.dados.nfe !== null){         
             setNumeroNF(response.data.dados.nfe.nNF);
             setDataEmissao(response.data.dados.nfe.dataEmissao);          
             setChave(response.data.dados.nfe.chaveNFe);
             setNProtocolo(response.data.dados.nfe.numeroDeProtocolo);           
                    }
            

           

            if(response.data.dados.cabecalho !== null){
          setValorBc(response.data.dados.cabecalho.ICMSTot.vBC);
          setValorIcms(response.data.dados.cabecalho.ICMSTot.vICMS);        
          setValorBcSt(response.data.dados.cabecalho.ICMSTot.vBCST);
          setValorSt(response.data.dados.cabecalho.ICMSTot.vST);        
          setValorProd(response.data.dados.cabecalho.ICMSTot.vProd);
          setValorFrete(response.data.dados.cabecalho.ICMSTot.vFrete);
          setValorSeg(response.data.dados.cabecalho.ICMSTot.vSeg);
          setValorDesc(response.data.dados.cabecalho.ICMSTot.vDesc);       
          setValorIpi(response.data.dados.cabecalho.ICMSTot.vIPI);
          setValorOutros(response.data.dados.cabecalho.ICMSTot.vOutro);
          setValorNotaFiscal(response.data.dados.cabecalho.ICMSTot.vNF);
            }
         
          
                             
           
            
            
           }else{
            console.log('nao consegui localizar')
           }
            
           }                               
         )
         .catch(function (error) {
           console.log(error);
                   
         });  
      }

      useEffect(function(){
        if(Number(tag) < 0){
          return
        }else{
          api.post(vhostV1('webcash/compras/id'),{
            pagina: nPag,
            regPag: 10,
            id: id
          },config)
           .then(function (response) {
            console.log(response);
            
             if(response && response.data && response.data.dados){
  
              if(response.data.dados.quantidadeDePaginasTotal !== null){
                setTotalPaginas(response.data.dados.quantidadeDePaginasTotal); 
               }

               if(response.data.dados.dup !== null){
                setDuplicata(response.data.dados.dup);
               }
  
              if(response.data.dados.fornecedor !== null){
              setCnpjEmitente(response.data.dados.fornecedor.cnpj);          
              setRazaoEmitente(response.data.dados.fornecedor.nome); 
                       
              }
  
              if(response.data.dados.nfe !== null){         
            setNumeroNF(response.data.dados.nfe.nNF);
            setDataEmissao(response.data.dados.nfe.dataEmissao);          
            setChave(response.data.dados.nfe.chaveNFe); 
            setNProtocolo(response.data.dados.nfe.nNF);         
              }
  
              if(response.data.dados.endereco !== null){
            setCidade(response.data.dados.endereco.nomeMunicipio);
            setUf(response.data.dados.endereco.uf);
            setCep(response.data.dados.endereco.cep);
            setBairro(response.data.dados.endereco.bairro);
            setNumero(response.data.dados.endereco.numero);
            setCodMunicipal(response.data.dados.endereco.codigoMunicipal);
              }
  
              if(response.data.dados.cabecalho !== null){
                 setValorBc(response.data.dados.cabecalho.ICMSTot.vBC);
            setValorIcms(response.data.dados.cabecalho.ICMSTot.vICMS);        
            setValorBcSt(response.data.dados.cabecalho.ICMSTot.vBCST);
            setValorSt(response.data.dados.cabecalho.ICMSTot.vST);        
            setValorProd(response.data.dados.cabecalho.ICMSTot.vProd);
            setValorFrete(response.data.dados.cabecalho.ICMSTot.vFrete);
            setValorSeg(response.data.dados.cabecalho.ICMSTot.vSeg);
            setValorDesc(response.data.dados.cabecalho.ICMSTot.vDesc);       
            setValorIpi(response.data.dados.cabecalho.ICMSTot.vIPI);
            setValorOutros(response.data.dados.cabecalho.ICMSTot.vOutro);
            setValorNotaFiscal(response.data.dados.cabecalho.ICMSTot.vNF);
              }
           
            
                               
             
              if(response.data.dados.itens !== null){
              setItens(response.data.dados.itens);  
              setProdutos(response.data.dados.itens);
              }
              
             
             }else{
              console.log('nao consegui localizar')
             }
              
             }                               
           )
           .catch(function (error) {
             console.log(error);
                     
           });  
        } 
      },[nPag, att, tag])

      function modoEdicao(){
        setEdicaoOn(!edicaoOn);
      }

        function listaPessoa(e){ e.preventDefault(); api.post(vhostV1('webcash/cadastro/'), { loja: localStorage.getItem('loja'), empresa: 0, tipo:"", busca: buscaPessoa, pagina: nPag, regPag: 10, },config)
          .then(function (response) { setPessoas(response.data.dados); setResultPessoa(response.data.result); })
          .catch(function (error) { console.log(error); }); }
      
        function pesquisaPessoa(e){  api.post(vhostV1('webcash/cadastro/'+e), { loja: localStorage.getItem('loja'), empresa: 0, },config)
          .then(function (response) { adicionaCliente(e);setClienteId(e); setRazaoEmitente(response.data.dados.cadastro.RAZAO); setCnpjEmitente(response.data.dados.cadastro.CNPJ);  setBairro(response.data.dados.cadastro.BAIRRO); setCidade(response.data.dados.cadastro.CIDADE); setUf(response.data.dados.cadastro.ESTADO); setCep(response.data.dados.cadastro.CEP); setCodMunicipal(response.data.dados.cadastro.MUNICIPAL);  setNumero(response.data.dados.cadastro.NREND1); })
          .catch(function (error) { console.log(error); }); }

        function adicionaCliente(e){  api.post(vhostV1('webcash/vendas/adicionaCliente'), { cod_orcamento:Number(codCompra), cliente:Number(e), tipo:"C" },config).then(()=>{}).catch((err)=>{console.log(err)}); }  

        function openModalAddCliente(){ setIsNovoClienteOpen(true); }

      const handleEdit = (field, value, codProduto) => {
        setProdutos((prevState) => {
          return prevState.map((produto) => {
            if (produto.COD_PRODUTO === codProduto) {
              const novoValor = parseFloat(value.replace(",", ".")) || 0; // Converte "," para "." e mantém número válido
              return {
                ...produto,
                [field]: value, 
                TOTAL: novoValor * Number(produto.QTD),
              };
            }
            return produto;
          });
        });
      };
  return <div className="conteiner-fluid titulo ">
  <Navbar/>
  <Toolbar/>
      

  <ModalItens isOpen={isModalItensOpen}
                 onRequestClose={closeModalItens}
                 itens={itens}
                             
                 />

              

  <ModalProduto isOpen={isProdutoOpen}
                 setCodProduto={setcodProduto}
                 onRequestClose={closeModalProduto}
                 listarPesquisa={filtraProdutos}
                 setPesquisaProduto={setPesquisaProduto}
                 pesquisaProduto={pesquisaProduto}
                 setDescricao={setDescricao}
                 setVendaDefault={setVendaDefault}
                 abreLancaItem={abreLancaItem}
                 setCompra={setCompra}
                 itens={produtosBusca}
                 titulo="pesquisa de Produto"
                 setEstoque={setEstoque}
                 setNcm={setNcm}
                 />   

   <ModalCheckAssociar show={checkIsOpen} 
                  handleClose={closeModalCheck}
                  cod_compra={codCompra}
                  />             

{isEditandoOpen && produtoEditando && (
        <ModalEdicaoProduto
          produto={produtoEditando}
          onSave={salvarEdicao}
          onClose={fecharModal}
          cod_compra={codCompra}
        />
      )}                
           
  <div className="offset-2 col-8">
   
  <h5>Entrada de Nota</h5> 
  <div className="d-flex importacao justify-content-end">
  
    <button onClick={openModalCheck} className='btn btn-primary'>importar XML</button>
    {edicaoOn ? <button onClick={modoEdicao} className='btn btn-success ml-2'>Modo Edição</button> : <button onClick={modoEdicao} className='btn btn-danger ml-2'>Modo Edição</button>} 
    
  </div>  

<hr />
 <div className="conteiner-fluid">
 <form className="row tela">
 
    <div className="col-2">
        <label htmlFor="inputAddress" id='form-label'  className="form-label">COMPRA</label>
        <input type="text" value={codCompra} className="form-control" id="inputCodigo" tabIndex="1" disabled/>
    </div>

    <div className="col-7">
        <label htmlFor="inputAddress" id='form-label'  className="form-label">CHAVE DE ACESSO</label>
        <input type="text" value={chave} className="form-control" id="inputCodigo" tabIndex="1"  disabled/>
    </div>

    <div className="col-2">
        <label htmlFor="inputAddress" id='form-label'  className="form-label">DATA</label>
        <input type="text"  value={dataAtual} id='data-label' className="form-control" disabled/>
    </div>

    <div className="col-2">
        <label htmlFor="inputAddress" id='form-label'  className="form-label">DATA EMISSÃO</label>
        <input type="text"  value={dataEmissao ? formatDate(dataEmissao): null} id='data-label' className="form-control" disabled/>
    </div>

    <div className="col-7">
        <label htmlFor="inputAddress" id='form-label'  className="form-label">NUMERO DA NOTA FISCAL</label>
        <input type="text"  value={nProtocolo} id='data-label' className="form-control" disabled/>
    </div>

    

    <nav>
             <div className="nav nav-tabs mt-4 mb-2" id="nav-tab" role="tablist">
                 <button className="nav-link active" id="nav-fornecedor-tab" data-bs-toggle="tab" data-bs-target="#nav-fornecedor" type="button" role="tab" aria-controls="nav-fornecedor" aria-selected="true" tabIndex="0">FORNECEDOR</button>
                 <button className="nav-link" id="nav-produtos-tab" data-bs-toggle="tab" data-bs-target="#nav-produtos" type="button" role="tab" aria-controls="nav-produtos" aria-selected="false" tabIndex="0">PRODUTOS</button>
                 <button className="nav-link" id="nav-financeiro-tab" data-bs-toggle="tab" data-bs-target="#nav-financeiro" type="button" role="tab" aria-controls="nav-financeiro" aria-selected="false" tabIndex="0">FINANCEIRO</button>
                 
             </div>
            </nav>
    
   
            <div className="tab-content" id="nav-tabContent">
            <div className="tab-pane fade show active" id="nav-fornecedor" role="tabpanel" aria-labelledby="nav-fornecedor-tab" tabIndex="0">
    
    <div className='row justify-content-center'>

  {/* RAZÃO + BOTÕES */}
  <div className="col-8">
    <label className="form-label">RAZÃO</label>
    <div className="input-group">
      <input
        type="text"
        value={razaoEmitente}
        className="form-control"
        disabled
      />

     
      {/* <button
        className="btn btn-primary"
        onClick={openModalAddCliente}
        type="button"
      >
        <i className="fas fa-plus-circle"></i>
      </button> */}

      {/* 🔍 Pesquisar cliente */}
      <button
        type="button"
        className="btn btn-secondary"
        data-bs-toggle="modal"
        data-bs-target="#modalClienteCompra"
      >
        Pesquisar (F1)
      </button>
    </div>
  </div>

  {/* CNPJ */}
  <div className="col-4">
    <label className="form-label">CNPJ</label>
    <input type="text" value={cnpjEmitente} className="form-control" disabled />
  </div>

  {/* RESTANTE DOS CAMPOS */}
  <div className="col-4">
    <label className="form-label">CIDADE</label>
    <input type="text" value={cidade} className="form-control" disabled />
  </div>

  <div className="col-4">
    <label className="form-label">COD. MUNICIPAL</label>
    <input type="text" value={codMunicipal} className="form-control" disabled />
  </div>

  <div className="col-4">
    <label className="form-label">UF</label>
    <input type="text" value={uf} className="form-control" disabled />
  </div>

  <div className="col-4">
    <label className="form-label">CEP</label>
    <input type="text" value={cep} className="form-control" disabled />
  </div>

  <div className="col-4">
    <label className="form-label">BAIRRO</label>
    <input type="text" value={bairro} className="form-control" disabled />
  </div>

  <div className="col-4">
    <label className="form-label">NUMERO</label>
    <input type="text" value={numero} className="form-control" disabled />
  </div>

  {/* ================= MODAL ================= */}
  <div
    className="modal fade mt-5"
    id="modalClienteCompra"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    aria-hidden="true"
  >
    <div className="modal-dialog modal-lg">
      <div className="modal-content">

        <div className="modal-header">
          <h1 className="modal-title fs-5">Pesquisa Cadastro</h1>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
          ></button>
        </div>

        <div className="modal-body">

          {/* 🔍 BUSCA */}
          <div className="input-group mb-3">
            <input
              onChange={(e) => setBuscaPessoa(e.target.value)}
              type="text"
              className="form-control"
              placeholder="Digite sua pesquisa"
              autoFocus
            />

            <button
              onClick={listaPessoa}
              className="btn btn-primary"
              type="button"
            >
              <i className="fas fa-search"></i> Pesquisar
            </button>
          </div>

          {/* 📋 RESULTADO */}
          {resultPessoa === 1 ? (
            <table className="table table-hover table-striped">
              <thead>
                <tr>
                  <th>CNPJ</th>
                  <th>Razão</th>
                  <th>Ação</th>
                </tr>
              </thead>

              <tbody className="table-group-divider">
                {pessoas.map((pessoa) => (
                  <tr key={pessoa.COD_CADASTRO}>
                    <td>{pessoa.CNPJ}</td>
                    <td>{pessoa.RAZAO}</td>
                    <td>
                      <button
                      type="button"
                        onClick={() => {
                          pesquisaPessoa(pessoa.COD_CADASTRO);

                          // 👉 FECHA MODAL
                          const modal = document.getElementById("modalClienteCompra");
                          const modalInstance = window.bootstrap.Modal.getInstance(modal);
                          modalInstance.hide();
                        }}
                      >
                        <i className="bi bi-file-arrow-down-fill"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <BuscaVazaia />
          )}

        </div>

        <div className="modal-footer"></div>
      </div>
    </div>
  </div>
</div>
    </div>
    <div className="tab-pane fade" id="nav-produtos" role="tabpanel" aria-labelledby="nav-produtos-tab" tabIndex="1">
    <div className='row justify-content-center'>
      <h5>Informações da Nota</h5>

      <div className="col-3">
        <label htmlFor="inputAddress" id='form-label'  className="form-label">Valor Base Calculo</label>
        <input type="text" onChange={(e) => setValorBc(e.target.value)} value={valorBc?.toLocaleString("pt-br", {style:"currency", currency:"BRL"})} className="form-control" id="inputCodigo" tabIndex="1" />
    </div>
    <div className="col-3">
        <label htmlFor="inputAddress" id='form-label'  className="form-label">Valor ICMS</label>
        <input type="text" onChange={(e) => setValorIcms(e.target.value)} value={valorIcms?.toLocaleString("pt-br", {style:"currency", currency:"BRL"})} className="form-control" id="inputCodigo" tabIndex="2" />
    </div>
   
    <div className="col-2">
        <label htmlFor="inputAddress" id='form-label'  className="form-label">Base Calculo ST</label>
        <input type="text" onChange={(e) => setValorBcSt(e.target.value)} value={valorBcSt?.toLocaleString("pt-br", {style:"currency", currency:"BRL"})} className="form-control" id="inputCodigo" tabIndex="5" />
    </div>
    <div className="col-2">
        <label htmlFor="inputAddress" id='form-label'  className="form-label">Valor ST</label>
        <input type="text" onChange={(e) => setValorSt(e.target.value)} value={valorSt?.toLocaleString("pt-br", {style:"currency", currency:"BRL"})} className="form-control" id="inputCodigo" tabIndex="6" />
    </div>
    
    <div className="col-2">
        <label htmlFor="inputAddress" id='form-label'  className="form-label">Valor Produtos</label>
        <input type="text" onChange={(e) => setValorProd(e.target.value)} value={valorProd?.toLocaleString("pt-br", {style:"currency", currency:"BRL"})} className="form-control" id="inputCodigo" tabIndex="9" />
    </div>
    <div className="col-2">
        <label htmlFor="inputAddress" id='form-label'  className="form-label">Valor Frete</label>
        <input type="text" onChange={(e) => setValorFrete(e.target.value)} value={valorFrete?.toLocaleString("pt-br", {style:"currency", currency:"BRL"})} className="form-control" id="inputCodigo" tabIndex="10" />
    </div>
    <div className="col-2">
        <label htmlFor="inputAddress" id='form-label'  className="form-label">Valor Seguro</label>
        <input type="text" onChange={(e) => setValorSeg(e.target.value)} value={valorSeg?.toLocaleString("pt-br", {style:"currency", currency:"BRL"})} className="form-control" id="inputCodigo" tabIndex="11" />
    </div>
    <div className="col-2">
        <label htmlFor="inputAddress" id='form-label'  className="form-label">Desconto</label>
        <input type="text" onChange={(e) => setValorDesc(e.target.value)} value={valorDesc?.toLocaleString("pt-br", {style:"currency", currency:"BRL"})} className="form-control" id="inputCodigo" tabIndex="12" />
    </div>
    <div className="col-2">
        <label htmlFor="inputAddress" id='form-label'  className="form-label">Outros Desp.</label>
        <input type="text" onChange={(e) => setValorOutros(e.target.value)} value={valorOutros?.toLocaleString("pt-br", {style:"currency", currency:"BRL"})} className="form-control" id="inputCodigo" tabIndex="18" />
    </div>
    <div className="col-2">
        <label htmlFor="inputAddress" id='form-label'  className="form-label">Valor IPI</label>
        <input type="text" onChange={(e) => setValorIpi(e.target.value)} value={valorIpi?.toLocaleString("pt-br", {style:"currency", currency:"BRL"})} className="form-control" id="inputCodigo" tabIndex="14" />
    </div>
    
    <div className="col-2">
        <label htmlFor="inputAddress" id='form-label'  className="form-label">Valor Nota Fiscal</label>
        <input type="text" onChange={(e) => setValorNotaFiscal(e.target.value)} value={valorNotaFiscal?.toLocaleString("pt-br", {style:"currency", currency:"BRL"})} className="form-control" id="inputCodigo" tabIndex="19" />
    </div>
   
    </div>
    <div className="row mt-3 lista-produtos" >
      <div className="d-flex row justify-content-between">
        <h6>ITENS DA NOTA</h6>  
       { edicaoOn ?
       <div className='d-flex'>
        <button className='btn btn-primary btn-cli mb-2' onClick={(e) => openModalProduto(e)} ><i className="bi bi-plus-circle-fill"></i>Adicionar Produto</button>
       </div>
             
         : null} 
           </div>       
           <div className="table-responsive">
            <table id='inputCodigo' className="table table-hover table-striped">
            <thead>
            <tr>
                <th scope="col">AÇÃO</th>
                <th scope="col">ASSOCIADO</th>
                <th scope="col">CODIGO</th>
                <th scope="col">DESCRIÇÃO</th>
                <th scope="col">UNIDADE</th>
                <th scope="col">CFOP</th>               
                <th scope="col">VALOR</th>
                <th scope="col">QTD</th>
                <th scope="col">TOTAL</th>
                <th scope="col">CST(ICMS)</th>
                <th scope="col">BC(ICMS)</th>
                <th scope="col">%(ICMS)</th>
                <th scope="col">VALOR(ICMS)</th>
                <th scope="col">CST(IPI)</th>
                <th scope="col">BC(IPI)</th>
                <th scope="col">%(IPI)</th>
                <th scope="col">VALOR(IPI)</th>
                <th scope="col">CST(PIS)</th>
                <th scope="col">BC(PIS)</th>
                <th scope="col">%(PIS)</th>
                <th scope="col">VALOR(PIS)</th>
                <th scope="col">CST(COFINS)</th>
                <th scope="col">BC(COFINS)</th>
                <th scope="col">%(COFINS)</th>
                <th scope="col">VALOR(COFINS)</th>
                
                

            </tr>
            </thead>
            
            <tbody className="table-group-divider">
            { produtos?.map((p)=> {
                return <tr key={p.COD_PRODUTO}>
                    <td>
                    <div className="btn-group dropend">
  <button
    className="btn btn-outline-secondary dropdown-toggle"
    type="button"
    data-bs-toggle="dropdown"
    aria-expanded="false"
  >
    Opções
  </button>
  <ul className="dropdown-menu">
    <li>
      <a
        className="dropdown-item"
        onClick={() => abreModalEdicao(p)}
      >
        <i className="bi bi-pen-fill"></i> Editar
      </a>
    </li>
  </ul>
</div>
</td>
<td>
  {p.RELACAO ? (
    <i className="bi bi-check-circle" style={{ color: 'green' }}></i>
  ) : (
    <i className="bi bi-x-circle" style={{ color: 'red' }}></i>
  )}
</td>
<td>{p.COD_PRODUTO || ""}</td>         
<td>{p.DESCRICAO || ""}</td>
<td>{p.UNIDADE || ""}</td>
<td>{p.CFOP || ""}</td>
<td>{"R$ " + Number(p.COMPRA || 0).toFixed(2)}</td>
<td>{Number(p.QTD || 0).toFixed(2)}</td>
<td>{"R$ " + Number(p.TOTAL || 0).toFixed(2)}</td>
<td>{p.ST_ICMS || ""}</td>
<td>{"R$ " + Number(p.BC_ICMS || 0).toFixed(2)}</td>
<td>{Number(p.ALI_ICMS || 0).toFixed(2) + " %"}</td>
<td>{"R$ " + Number(p.VALOR_ICMS || 0).toFixed(2)}</td>
<td>{p.ST_IPI || ""}</td>
<td>{"R$ " + Number(p.BC_IPI || 0).toFixed(2)}</td>
<td>{Number(p.ALI_IPI || 0).toFixed(2) + " %"}</td>
<td>{"R$ " + Number(p.VALOR_IPI || 0).toFixed(2)}</td>
<td>{p.ST_PIS || ""}</td>
<td>{"R$ " + Number(p.BC_PIS || 0).toFixed(2)}</td>
<td>{Number(p.ALI_PIS || 0).toFixed(2) + " %"}</td>
<td>{"R$ " + Number(p.VALOR_PIS || 0).toFixed(2)}</td>
<td>{p.ST_COFINS || ""}</td>
<td>{"R$ " + Number(p.BC_COFINS || 0).toFixed(2)}</td>
<td>{Number(p.ALI_COFINS || 0).toFixed(2) + " %"}</td>
<td>{"R$ " + Number(p.VALOR_COFINS || 0).toFixed(2)}</td>
                    
                </tr>
            } )}  
            </tbody>
            
            </table>

            </div> 
           
         </div>

         <div className="row mt-5 mb-5">
            <SRI_pagination totalPage={totalPaginas} 
                            page={nPag} 
                            limit={10} 
                            siblings={1}
                            onPageChange={handlePageChange}/>
            </div>
      
          </div>
          <div className="tab-pane fade" id="nav-financeiro" role="tabpanel" aria-labelledby="nav-financeiro-tab" tabIndex="1">
          <h5 className="mt-4">Duplicatas</h5>
                    <div className='row d-flex'>
                     {duplicata.map((dup) => (
                    <div key={dup.nDup} className="mb-3">
                        <div className="col-12 d-flex">       
                     <input className="form-control col-3 mr-3" value={`Duplicata ${dup.nDup}`} readOnly/>
                     <input type="text" className="form-control mb-2 mr-3 col-3" value={`Vencimento: ${validarData(dup.dVenc)}`} readOnly />
                     <input type="text" className="form-control col-3" value={`Valor: R$ ${Number(dup.vDup).toLocaleString("pt-br", { style: "currency", currency: "BRL" })}`} readOnly />
                    </div>
                    </div>
                    ))}
                    </div>
    

          </div>
         </div>

         

         <div className="col-12 footer-cart mb-5">
                   
                         <Button  type="button" onClick={() => handleClosePage()} className="btn btn-danger butao"  tabIndex="14">Desistir</Button>
                       {  Number(tag) !== 0 ?
                           <button type="submit" onClick={salvaConta} className="btn btn-primary butao" tabIndex="13">Salvar</button> : null
                       }
                       
                       

         </div>
           {erroValidacao && (
             <SweetAlert
               danger
               confirmBtnText="OK"
               confirmBtnBsStyle="danger"
               title="Erro"
               onConfirm={() => setErroValidacao(false)}
             >
               {msgErro}
             </SweetAlert>
           )}
         {sucesso === "S" ? <Navigate to="/app/estoque/compra"/> : null}
          {resetar === "S" ? <Navigate to={`/app/estoque/novaCompra/${codCompra}/2`} /> : null}
    </form>
    </div>
  </div> 
  <FooterBar/>
  </div> 

  
}

export default NovaCompra